module.exports = __webpack_public_path__ + "res/img/download_page_bg_001.a8ee4ad6.png";